import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

import { HandleError, HttpErrorHandler } from '@shared/services/error-handler/http-error-handler.service';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {
  private readonly handleError: HandleError;

  constructor(
    private readonly httpClient: HttpClient,
    private readonly router: Router,
    private httpErrorHandler: HttpErrorHandler
  ) {
    this.handleError = httpErrorHandler.createHandleError('Download Service');
  }

  /**
   * Downloads a file and returns it as a Blob
   * @param url The URL to download from
   * @returns Observable of HttpResponse containing the file as a Blob
   */
  downloadFile(url: string): Observable<HttpResponse<Blob>> {
    return this.httpClient.get<HttpResponse<Blob>>(url, { observe: 'response', responseType: 'blob' as 'json' }).pipe(catchError(this.handleError('Download Service', null)))
  }

  /**
   * Downloads a file and returns it as text
   * @param url The URL to download from
   * @returns Observable of HttpResponse containing the file as text
   */
  downloadBinaryFile(url: string): Observable<HttpResponse<string>> {
    return this.httpClient.get<HttpResponse<string>>(url, { observe: 'response', responseType: 'text' as 'json' }).pipe(catchError(this.handleError('Download Service', null)))
  }
}
